import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    NumericInputStepButtonDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    getFocusRingStyle
} from "../../../../helpers/theme/state";
import {
    getCornerStyle
} from "../../../../helpers/theme/corner";
import {
    webStyle
} from "../../../../utils";

const stylesheet = StyleSheet.create({
    stepContainer: {
        justifyContent: "center",
        ...webStyle({
            outlineStyle: "solid",
            outlineWidth: 0
        })
    },
    stepSurface: {
        justifyContent: "center",
        alignItems: "center"
    },
    incrementContainer: {
        alignItems: "flex-start"
    },
    decrementContainer: {
        alignItems: "flex-end"
    }
});

export const useStyles = ({
    isFocusVisible,
    shapeConfigs,
    stepperSize,
    direction,
    borders,
    colors
}: NumericInputStepButtonDynamicStyleType) => {
    const styles = {
        container: {
            width: stepperSize.side + stepperSize.hitExtension,
            marginVertical: -stepperSize.hitExtension,
            height: stepperSize.hitSize
        } as Mutable<ViewStyle>,
        surface: {
            ...getCornerStyle({
                radius: stepperSize.radius,
                shapeConfigs
            }),
            height: stepperSize.side,
            width: stepperSize.side
        } as Mutable<ViewStyle>
    };

    if(direction === "decrement") {
        Object.assign(styles.container, stylesheet.decrementContainer);

        styles.container.marginStart = -stepperSize.hitExtension;
    } else {
        Object.assign(styles.container, stylesheet.incrementContainer);

        styles.container.marginEnd = -stepperSize.hitExtension;
    }

    Object.assign(styles.surface, getFocusRingStyle({
        colorKey: "default",
        isFocusVisible,
        borders,
        colors
    }));

    delete styles.surface.outlineOffset;

    return styles;
};
export default stylesheet;
